import { render, staticRenderFns } from "./IdentityInfo.vue?vue&type=template&id=c6998376&scoped=true&"
import script from "./IdentityInfo.vue?vue&type=script&lang=js&"
export * from "./IdentityInfo.vue?vue&type=script&lang=js&"
import style0 from "./IdentityInfo.vue?vue&type=style&index=0&id=c6998376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6998376",
  null
  
)

component.options.__file = "IdentityInfo.vue"
export default component.exports